'use client';

import { getLocalizedFooterCopy } from '../localization';
import { cn } from '../ui/utils';

interface FormFooterProps {
  className?: string;
  termsUrl?: string;
  privacyUrl?: string;
  lang?: string | null;
}

const DEFAULT_LINKS = {
  TERMS_OF_USE: 'https://www.capterra.com/legal/terms-of-use/',
  PRIVACY_POLICY: 'https://www.capterra.com/legal/privacy-policy/',
};

export const FormFooter = ({
  className,
  termsUrl = DEFAULT_LINKS.TERMS_OF_USE,
  privacyUrl = DEFAULT_LINKS.PRIVACY_POLICY,
  lang,
}: FormFooterProps) => {
  const copy = getLocalizedFooterCopy(lang);

  return (
    <p
      className={cn(
        'mt-4 pb-2 text-left text-[14px] leading-5 text-nimbus-muted-foreground',
        className
      )}
    >
      {copy.beforeTerms}
      <a
        href={termsUrl}
        className="font-semibold text-nimbus-accent-foreground hover:text-nimbus-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        {copy.termsLabel}
      </a>
      {copy.betweenTermsAndPrivacy}
      <a
        href={privacyUrl}
        className="font-semibold text-nimbus-accent-foreground hover:text-nimbus-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        {copy.privacyLabel}
      </a>
      {copy.afterPrivacy}
    </p>
  );
};
